/// <reference path="UtentiProdottiBadgeGrid.ts"/>

namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass("Gamification.Gamification.UtentiProdottiBadgeDetailGrid")
    export class UtentiProdottiBadgeDetailGrid extends Gamification.UtentiProdottiBadgeGrid {
        constructor(container: JQuery) {
            super(container);
        }

        protected usePager() {
            return false;
        }

        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();

            // Remove Button
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "column-picker-button"), 1);

            // Remove Button
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            return buttons;
        }

        protected getGridCanLoad() {
            return super.getGridCanLoad() && !!this.IdUtenteProdottoBadge;
        }

        private _IdUtenteProdottoBadge: number;

        get IdUtenteProdottoBadge() {
            return this._IdUtenteProdottoBadge;
        }

        set IdUtenteProdottoBadge(value: number) {
            if (this._IdUtenteProdottoBadge !== value) {
                this._IdUtenteProdottoBadge = value;
                this.setEquality('IdUtenteProdottoBadge', value);
                this.refresh();
            }
        }
    }
}